<template>
  <UC :menus="menus"></UC>
</template>

<script>
  import UC from '@/page/modules/uc/index'
  export default {
    components: { UC },
    data () {
      return {
        menus: [{
          id: '0122',
          name: '我的课程',
          path: '/entrain/uc/record',
          iconClass: 'icon_a'
        }, {
          id: '0131',
          name: '我的学时',
          path: '/entrain/uc/lrecord',
          iconClass: 'icon_a'
        }, {
          id: '0123',
          name: '我的收藏',
          path: '/entrain/uc/fav',
          iconClass: 'icon_b'
        }, {
          id: '0124',
          name: '我的考试',
          path: '/entrain/uc/examination',
          iconClass: 'icon_c'
        }, {
          id: '0125',
          name: '我的报名',
          path: '/entrain/uc/enroll',
          iconClass: 'icon_c'
        }, {
          id: '0126',
          name: '我的证书',
          path: '/entrain/uc/certificate',
          iconClass: 'icon_d'
        }, {
          id: '0127',
          name: '我的消息',
          path: '/entrain/uc/message',
          iconClass: 'icon_e'
        }, {
          id: '0128',
          name: '资料设置',
          path: '/entrain/uc/set',
          iconClass: 'icon_f'
        }, {
          id: '0129',
          name: '我的订单',
          path: '/entrain/uc/order',
          iconClass: 'icon_h'
        },{
          id: '0130',
          name: '我的开票',
          path: '/entrain/uc/invoice',
          iconClass: 'icon_h'
        }]
      }
    }
  }
</script>

<style scoped>
  .member_top { margin-top: 0px; }
</style>



// WEBPACK FOOTER //
// src/page/entrain/uc/index.vue